import { restClient } from '../../client';

export type SetProviderStateInput = {
  id: string;
};

export type SetProviderStateOutput = {
  status: string;
} | {
  error: string;
};

export const setProviderRegular = (params: SetProviderStateInput) => restClient.request<SetProviderStateOutput>('/api/v1/onboarding/set_provider_regular', {
  method: 'POST',
  data: params,
});
